import * as React from 'react';

import PageNavigation from 'components/common/PageNavigation';
import DataWarehouseRoutes from 'data-warehouse/Routes';
import { Row } from 'components/bootstrap';

const DataWarehousePageNavigation = () => {
  const NAV_ITEMS = [
    { title: 'Overview', path: DataWarehouseRoutes.ARCHIVE.LIST, exactPathMatch: true },
    { title: 'Backend', path: DataWarehouseRoutes.BACKEND, exactPathMatch: true },
    { title: 'Configuration', path: DataWarehouseRoutes.CONFIGURATION, exactPathMatch: true },
  ];

  return (
    <Row>
      <PageNavigation items={NAV_ITEMS} />
    </Row>
  );
};

export default DataWarehousePageNavigation;
